module.exports = __webpack_public_path__ + "img/bgIcon_6.93fdd358.png";